<template>
  <div class="text-center">
    <v-dialog v-model="dialog" persistent width="540">
      <v-card class="report-date-dialog">
        <div class="report-date-dialog__header">
          <div class="report-date-dialog__icon">
            <v-icon color="primary">mdi-calendar-range</v-icon>
          </div>
          <div>
            <h2>Select report period</h2>
            <p>Choose the dates to include in this report.</p>
          </div>
          <v-spacer />
          <v-btn icon aria-label="Close" @click="close">
            <v-icon>mdi-close</v-icon>
          </v-btn>
        </div>

        <v-divider />

        <v-card-text class="report-date-dialog__body">
          <div class="report-date-dialog__label">Date range</div>
          <DateTimePicker
            defaultRange="thisMonth"
            :range="true"
            :hideTime="true"
            v-model="dateTime"
          />

          <div class="report-date-dialog__selection">
            <v-icon size="19" color="primary">mdi-calendar-check-outline</v-icon>
            <div>
              <span>Selected period</span>
              <strong>{{ formattedPeriod }}</strong>
            </div>
          </div>
        </v-card-text>

        <v-divider />

        <v-card-actions class="report-date-dialog__actions">
          <v-btn text color="grey darken-1" @click="close">Cancel</v-btn>
          <v-btn
            color="primary"
            depressed
            class="report-date-dialog__button"
            :disabled="!dateTime || !dateTime.start || !dateTime.end"
            @click="createReport"
          >
            <v-icon left small>mdi-chart-box-outline</v-icon>
            View report
          </v-btn>
        </v-card-actions>
      </v-card>
    </v-dialog>
  </div>
</template>

<script>
const DateTimePicker = () => import("@/components/DateTimePicker");
import { mapGetters, mapActions } from "vuex";

export default {
  components: { DateTimePicker },
  data() {
    return {
      dialog: false,
      dateTime: this.thisMonth(),
    };
  },
  computed: {
    ...mapGetters("reportView", ["getDateSelector"]),
    formattedPeriod() {
      if (!this.dateTime || !this.dateTime.start || !this.dateTime.end) return "Choose a date range";
      const start = this.$moment(this.dateTime.start).format("MMM D, YYYY");
      const end = this.$moment(this.dateTime.end).format("MMM D, YYYY");
      return `${start} – ${end}`;
    },
  },
  watch: {
    getDateSelector(val) {
      if (val) this.dateTime = this.thisMonth();
      this.dialog = val;
    },
  },
  methods: {
    ...mapActions("reportView", ["setDateSelector"]),
    thisMonth() {
      return {
        range: "thisMonth",
        start: this.$moment().startOf("month").toISOString(),
        end: this.$moment().endOf("month").toISOString(),
      };
    },
    close() {
      this.setDateSelector(false);
    },
    createReport() {
      this.$emit("submit", this.dateTime);
      this.close();
    },
  },
};
</script>

<style scoped>
.report-date-dialog { border-radius: 14px !important; overflow: hidden; }
.report-date-dialog__header { display: flex; align-items: center; gap: 13px; padding: 20px 20px 18px; text-align: left; }
.report-date-dialog__header h2 { margin: 0; color: #202b3c; font-size: 19px; line-height: 1.3; }
.report-date-dialog__header p { margin: 3px 0 0; color: #748094; font-size: 12px; }
.report-date-dialog__icon { display: flex; align-items: center; justify-content: center; width: 43px; height: 43px; border-radius: 11px; background: rgba(25, 118, 210, .08); }
.report-date-dialog__body { padding: 22px 24px 24px; }
.report-date-dialog__label { margin-bottom: 7px; color: #4c596d; font-size: 12px; font-weight: 700; text-align: left; text-transform: uppercase; letter-spacing: .045em; }
.report-date-dialog__body ::v-deep .v-input__slot { min-height: 46px; border-radius: 9px; box-shadow: none !important; }
.report-date-dialog__selection { display: flex; align-items: center; gap: 11px; margin-top: 16px; padding: 13px 15px; border: 1px solid #e2e8f0; border-radius: 10px; background: #f8fafc; text-align: left; }
.report-date-dialog__selection span, .report-date-dialog__selection strong { display: block; }
.report-date-dialog__selection span { color: #7a8699; font-size: 11px; }
.report-date-dialog__selection strong { margin-top: 2px; color: #2c374a; font-size: 13px; }
.report-date-dialog__actions { justify-content: flex-end; gap: 6px; padding: 14px 20px; }
.report-date-dialog__button { border-radius: 8px; text-transform: none; }
@media (max-width: 600px) {
  .report-date-dialog__header { padding: 17px 16px; }
  .report-date-dialog__body { padding: 20px 16px; }
}
</style>
